.root {
    margin-block: var(--spacer-48);
}

// Keeps the anchor box wrapped tightly around the badge. Without it the
// anchor is an inline box holding a block-level image, which leaves the
// focus outline detached from the thing being focused.
.link {
    display: inline-block;
}

.badge {
    display: block;
    height: auto;
    max-width: 100%;
}
